import axiosInstance from "./axiosInstance";

const InvoiceService = {
    search: (page, size, filters) =>
        axiosInstance.post(`/api/invoices/search?page=${page}&size=${size}&sort=invoiceDate,desc`, filters).then(r => r.data),

    getById: (id) =>
        axiosInstance.get(`/api/invoices/${id}`).then(r => r.data),
};

export default InvoiceService;
